import React, { Fragment } from "react";
import { Routes, Route } from "react-router-dom";
import ApprovalScreen from "../../auth/approvalScreen";
import Unauthorized from "../../auth/unauthorized";
import ShopDetails from "../../auth/signUpOnboard/onboarding/shopDetails";
import SignUpOnboarding from "../../auth/signUpOnboard";
import EmailPhoneVerification from "../../auth/signUpOnboard/emailPhoneVerification";
import PersonalDetails from "../../auth/signUpOnboard/onboarding/personalDetails";
import VehicalDetails from "../../auth/signUpOnboard/onboarding/vehicalDetails";

const PreAuthLayout = () => {
  // const location = useLocation();

  return (
    <Fragment>
      <div className="pt-[81px]">
        <Routes>
            <Route path="" element={<SignUpOnboarding />}>
            <Route path="account" element={<EmailPhoneVerification />} />
            <Route path="register" element={<PersonalDetails />} />
            <Route path="business-details" element={<ShopDetails />} />
            <Route path="delivery-details" element={<VehicalDetails />} />
          </Route>
          <Route path="approval" element={<ApprovalScreen />} />
          <Route path="unauthorized" element={<Unauthorized />} />
        </Routes>
      </div>
    </Fragment>
  );
};

export default PreAuthLayout;
